// import components
import { styled, Box } from '@mui/material';

export const StyledHighlightedCell = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'style'
})<{
  color?:
    | 'errorBg'
    | 'infoBg'
    | 'warningBg'
    | 'successBg'
    | 'primaryBg'
    | 'secondaryBg';
  style?: 'corner' | 'line';
}>(({ theme, color = 'errorBg', style = 'corner' }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  width: style === 'corner' ? 0 : theme.spacing(1),
  height: style === 'corner' ? 0 : '100%',
  ...(style === 'corner' && {
    borderLeft: '14px solid transparent',
    borderTop: `14px solid ${theme.vars.palette.LinearProgress[color]}`
  }),
  ...(style === 'line' && {
    backgroundColor: theme.vars.palette.LinearProgress[color]
  })
}));
